/**
 * Static registry of animated icon names, the imperative handle type, and
 * shared constants used by both the static and animated icon paths.
 */

/** Design system stroke weight for all icons, static and animated. Never override per usage. */
export const ICON_STROKE_WIDTH = 2;

/** Imperative handle returned by animated icon refs — used by `AnimatedIcon.tsx` to start/stop animations programmatically. */
export type AnimatedIconHandle = {
  startAnimation: () => void;
  stopAnimation: () => void;
};

/** All icon names that have an animated variant. Add here AND in `map.ts` to unlock `animate` prop support for a new icon. */
export const ANIMATED_ICON_NAMES = [
  'arrow-up',
  'bookmark',
  'circle-help',
  'graduation-cap',
  'history',
  'layers',
  'message-circle-plus',
  'route',
  'users',
  'wrench',
] as const;

export type AnimatedIconName = (typeof ANIMATED_ICON_NAMES)[number];
